export default __webpack_public_path__ + "static/factoryimage-11e4672b68026795476d39ee18615fb2.png";